require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./avicii-mental-health-electronic-music.json") })
        }
      }, "path---avicii-mental-health-electronic-music");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---avicii-mental-health-electronic-music!./.cache/json/avicii-mental-health-electronic-music.json
// module id = 631
// module chunks = 231608221292675